import { BrandKit } from '@goldcast/api/backend';

import { PLATFORM_BRAND_KIT_KEYS } from './constants';
import { BrandKitFont } from './types';

import { getPlatformFontDisplayName } from '@/utils/fonts';

export function extractFontsFromBrandKits(brandKits: BrandKit[]): { name: string; url: string }[] {
  const result: { name: string; url: string }[] = [];

  for (const bk of brandKits) {
    const fonts = (bk.fonts ?? {}) as Record<string, BrandKitFont | undefined>;
    for (const key of PLATFORM_BRAND_KIT_KEYS) {
      const font = fonts[key];
      if (font?.url && font?.originalName) {
        result.push({ name: getPlatformFontDisplayName(font.originalName), url: font.url });
      }
    }
  }

  return result;
}
